<template>
  <div
    class="w-1/6 pt-4 text-center"
    :id="step.id">
    <router-link
      :to="step.route"
      :id="step.id"
      class="flex flex-col items-center justify-center">
      <RingSvg
        v-if="isActive"
        :id="step.id"
        class="fill-royal-blue-100 h-6 w-6 mt-1"
        :strokeWidth="4" />
      <SuccessIcon
        v-else-if="isCompleteOk"
        :id="step.id"
        class="text-white bg-royal-blue-100 rounded-full h-6 w-6 mt-1"
      />
      <WarningIcon
        v-else-if="isWarning"
        :id="step.id"
        class="h-6 w-6 mt-1 text-royal-blue-100"/>
      <RingSvg
        v-else
        :id="step.id"
        class="fill-royal-blue-100 h-6 w-6 mt-1" />
      <a
        class="text-center text-royal-blue-100 hover:text-royal-blue-160 underline mt-2"
        :class="{ 'font-bold !no-underline': isActive }"
        v-html="step.name"
        :id="step.id + 'Title'"
      >
      </a>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Step } from '@/types'
import RingSvg from '../../images/svg/progress-tracker/RingSvg.vue'
import SuccessIcon from '../../images/svg/progress-tracker/TickSvg.vue'
import WarningIcon from '../../images/svg/progress-tracker/ExclamationCircleIcon.vue'

const props = defineProps({
  step: { required: true, type: Object as () => Step },
})

const isActive = computed((): boolean => {
  return props.step.isActive
})

const isCompleteOk = computed((): boolean => {
  return props.step.isComplete && props.step.isValid
})

const isWarning = computed((): boolean => {
  return props.step.isComplete && !props.step.isValid
})
</script>
